import { PropertyDetails } from "./types";

export const getAllDifferentNeedsAttentionReasons = ({
	properties,
}: {
	properties: PropertyDetails[];
}) => {
	const reasons = [];
	for (const property of properties) {
		for (const appeal of property.appeals) {
			reasons.push(...appeal.needs_attention_reason);
		}
	}
	return reasons
		.map(reason => reason.name)
		.filter((value, index, self) => self.indexOf(value) === index);
};
